import { Button } from "@/lib/components/Button/Button";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { CallbackListener } from "@remotion/player";
import {
  IconPlayerPauseFilled,
  IconPlayerPlayFilled,
} from "@tabler/icons-react";
import { SyntheticEvent, useCallback, useEffect, useState } from "react";

export default function VideoPreviewPlay() {
  const playerRef = useEditorStore((state) => state.service.getPlayerRef());
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = useCallback(
    (e: SyntheticEvent) => {
      playerRef?.current?.toggle(e);
    },
    [playerRef],
  );

  useEffect(() => {
    const player = playerRef?.current;

    if (!player) {
      return;
    }

    const onPlay: CallbackListener<"play"> = () => {
      setIsPlaying(true);
    };

    const onPause: CallbackListener<"pause"> = () => {
      setIsPlaying(false);
    };

    player.addEventListener("play", onPlay);
    player.addEventListener("pause", onPause);

    return () => {
      if (player) {
        player.removeEventListener("play", onPlay);
        player.removeEventListener("pause", onPause);
      }
    };
  }, [playerRef]);

  return (
    <Button
      variant="ghost"
      size="iconSm"
      onClickCapture={togglePlay}
      className="text-text-primary [&_svg]:size-5"
    >
      {isPlaying ? <IconPlayerPauseFilled /> : <IconPlayerPlayFilled />}
    </Button>
  );
}
